if (!customElements.get("wls-variant-selector")) {
  class WLSVariantSelector extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        colorItem: "wls-product-card__color-item",
        active: "is-active",
        link: "wls-product-card__link",
        btn: "wls-product-card-btn",
        cardImage: "js-selected-product-card-image",
      };

      this.onItemClick = this.onItemClick.bind(this);
    }

    connectedCallback() {
      this.colorItems = Array.from(
        this.querySelectorAll(`.${this.classes.colorItem}`)
      );
      this.links = Array.from(this.querySelectorAll(`.${this.classes.link}`));
      this.btn = this.querySelector(`.${this.classes.btn}`);

      if (!this.colorItems.length) return;

      if (!this.colorItems.some((i) => i.classList.contains(this.classes.active))) {
        this.colorItems[0].classList.add(this.classes.active);
      }

      this.syncRelatedProductImages();
      this.syncProductCardImage();

      this.colorItems.forEach((item) =>
        item.addEventListener("click", this.onItemClick)
      );
    }

    disconnectedCallback() {
      this.colorItems?.forEach((item) =>
        item.removeEventListener("click", this.onItemClick)
      );
    }

    syncRelatedProductImages() {
      const variantImgs = this.querySelectorAll(".js-related-products-variant-image");
      if (!variantImgs.length) return;

      const defaultImg = this.querySelector(".js-related-products-default-image");
      const active = this.colorItems.find((i) =>
        i.classList.contains(this.classes.active)
      );
      const variantId = Number(active?.getAttribute("data-variant-id"));

      variantImgs.forEach((img) => {
        const id = Number(img.getAttribute("data-variant-id"));
        const match = Number.isFinite(variantId) && id === variantId;
        img.classList.toggle("is-active", match);
      });

      if (defaultImg) {
        const hasMatch =
          Number.isFinite(variantId) &&
          Array.from(variantImgs).some(
            (img) => Number(img.getAttribute("data-variant-id")) === variantId
          );
        defaultImg.classList.toggle("is-hidden", hasMatch);
      }
    }

    syncProductCardImage() {
      const img = this.querySelector(`img.${this.classes.cardImage}`);
      if (!img || !this.colorItems?.length) return;

      const active = this.colorItems.find((i) =>
        i.classList.contains(this.classes.active)
      );
      const src = active?.getAttribute("data-image")?.trim();
      if (!src) return;

      if (img.getAttribute("src") !== src) {
        img.src = src;
      }
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
    }

    buildVariantUrl(variantId) {
      const id = String(variantId);
      const fromAttr = this.dataset.productUrl?.trim();
      if (fromAttr) {
        const u = new URL(fromAttr, window.location.origin);
        u.searchParams.set("variant", id);
        return u.toString();
      }
      const ref = this.links?.[0] || this.querySelector(`.${this.classes.link}`);
      if (ref?.href) {
        const u = new URL(ref.href);
        if (u.pathname.includes("/products/")) {
          u.searchParams.set("variant", id);
          return u.toString();
        }
      }
      const u = new URL(window.location.href);
      u.searchParams.set("variant", id);
      return u.toString();
    }

    onItemClick(e) {
      const item = e.currentTarget;

      const variantId = Number(item.getAttribute("data-variant-id"));
      if (!Number.isFinite(variantId)) return;

      this.colorItems.forEach((i) => i.classList.remove(this.classes.active));
      item.classList.add(this.classes.active);

      this.syncRelatedProductImages();
      this.syncProductCardImage();

      const variantUrl = this.buildVariantUrl(variantId);

      this.links?.forEach((link) => (link.href = variantUrl));
      if (this.btn) this.btn.href = variantUrl;

      const next = new URL(variantUrl);
      if (next.pathname === window.location.pathname) {
        window.history.replaceState({}, "", variantUrl);
      }

      this.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: { variantId },
          bubbles: true,
        })
      );
    }
  }

  customElements.define("wls-variant-selector", WLSVariantSelector);
}
